import { useState, useEffect } from "react";
import axios from "axios";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPage() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setChecking(false); return; }
    axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem("admin_token"))
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#0A2540] flex items-center justify-center">
        <div className="text-white/30 font-['Manrope']">Chargement...</div>
      </div>
    );
  }

  if (!user) {
    return <AdminLogin onLogin={(data) => setUser(data)} />;
  }

  return <AdminDashboard onLogout={() => setUser(null)} />;
}
